import React from 'react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import InitialDrawerState from './initial-drawer-state';
import { novoAiExpandedReadOnlyWrapper } from '../styles';

interface AskNovoAIReadOnlyProps {
  firstName?: string;
}

const AskNovoAIReadOnly: React.FC<AskNovoAIReadOnlyProps> = ({ firstName }) => (
  <div css={novoAiExpandedReadOnlyWrapper}>
    <div className='novoai-drawer-header'>
      <div className='novoai-header-left'>
        <NvIcon icon='gen-ai' size='xss-small' className='icon-gradient' />
        <span className='novoai-title'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.ASK_NOVO_AI_DRAWER.TITLE()}
        </span>
      </div>
      <button
        className='novoai-drawer-close'
        aria-label='Close'
        onClick={() => null}
        type='button'
      >
        <NvIcon icon='arrow-up' size='xss-smallest' className='icon-gradient' />
      </button>
    </div>
    <div className='novoai-drawer-content'>
      <InitialDrawerState
        firstName={firstName}
        formFields=''
        setFormFields={() => null}
        onSubmit={() => null}
        readOnly
      />
    </div>
  </div>
);

export default AskNovoAIReadOnly;
